import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Paper,
  IconButton,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import MathuraLogo from "../../assets/logos/mathura.png";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import InfratecImg from "../../assets/MInfrat.png";
import InfrastructureImg from "../../assets/MInfras.png";
import M_InfratecImg from "../../assets/MInfratecImg.jpg";
import M_InfratecWOLic from "../../assets/MInfratecWOLic.jpg";
import MInfraSeal from "../../assets/Infrastructure_seal.png";
import MInfratecSeal from "../../assets/Infratec_seal.png";

//
// Remove homepage from package.json for original deployment
//
//
const GST_RATES = [0, 5, 12, 18, 28];
const CURRENCY_OPTIONS = [
  { code: "INR", symbol: "₹", label: "Rupee", name: "Rupees" },
  { code: "AED", symbol: "AED", label: "Dirham", name: "AED" },
  { code: "USD", symbol: "$", label: "Dollar", name: "USD" },
];

export default function MathuraInfrastructure() {
  // Supplier Details
  const supplierDetails = {
    name: "Mathura Infrastructure",
    addressline1: "No. 29/1, Pathivalar Colony, Madukkarai Road",
    addressline2: "Sundarapuram, Coimbatore - 641 024",
    gstin: "33ABQFM6593F1ZT",
    email: "support@mathuragroup.com",
    phone: "+91 63857 55443",
    bankAccName: "MATHURA INFRASTRUCTURE",
    bankName: "HDFC Bank",
    bankBranch: "Trichy Road, Coimbatore",
    bankIFSC: "HDFC0000031",
    bankAccNo: "50200069097120",
    logo: MathuraLogo,
  };

  const InfratecBank = {
    bankAccName: "MATHURA INFRATEC",
    bankName: "HDFC Bank",
    bankBranch: "Trichy Road, Coimbatore",
    bankIFSC: "HDFC0000031",
    bankAccNo: "50200109345011",
  };
  const InfrastructureHDFCBank = {
    bankAccName: "MATHURA INFRASTRUCTURE",
    bankName: "HDFC Bank",
    bankBranch: "Trichy Road, Coimbatore",
    bankIFSC: "HDFC0000031",
    bankAccNo: "50200069097120",
  };

  const InfrastructureBOBBank = {
    bankAccName: "MATHURA INFRASTRUCTURE",
    bankName: "Bank of Baroda",
    bankBranch: "Sundarapuram, Coimbatore",
    bankIFSC: "BARB0SUNCOI",
    bankAccNo: "47210200002010",
  };
  const MInfratecBank = {
    bankAccName: "M-INFRATEC LLC-FZ",
    bankName: "RAK Bank",
    bankBranch: "UMM HURRAIR, Dubai",
    IBANNumber: "AE210400000333569605001",
    bankAccNo: "0333569605001",
  };

  // Invoice & recipient state
  const [recipientName, setRecipientName] = useState("");
  const [recipientAddress1, setRecipientAddress1] = useState("");
  const [recipientAddress2, setRecipientAddress2] = useState("");
  const [recipientAddress3, setRecipientAddress3] = useState("");
  const [recipientGSTIN, setRecipientGSTIN] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [placeOfSupply, setPlaceOfSupply] = useState("");
  const [deliveryAddName, setDeliveryAddName] = useState("");
  const [deliveryAddress1, setDeliveryAddress1] = useState("");
  const [deliveryAddress2, setDeliveryAddress2] = useState("");
  const [deliveryAddress3, setDeliveryAddress3] = useState("");
  const [infratec, setInfratec] = useState(false);
  const [background, setBackground] = useState("None");
  const [backgroundImg, setBackgroundImg] = useState("");
  const [deliveryGSTIN, setDeliveryGSTIN] = useState("");
  const [deliveryto, setDeliveryto] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(false);
  const [quotation, setQuotation] = useState("Quotation");
  const [bank, setBank] = useState("hdfc_infras");
  const [bankDetails, setBankDetails] = useState("");
  const [seal, setSeal] = useState(false);
  // Toggles & rates
  const [applyGST, setApplyGST] = useState(false);
  const [gstType, setGstType] = useState("");
  const [gstRate, setGstRate] = useState(0);
  const [discountChecked, setDiscountChecked] = useState(false);
  const [discountRate, setDiscountRate] = useState(0);
  const [roundOff, setRoundOff] = useState(false);
  const [invoicedetails, setInvoicedetails] = useState(false);
  // Currency & extra/service charge
  const [currency, setCurrency] = useState("INR");
  const [extraType, setExtraType] = useState("amount"); // "amount" or "percent"
  const [extraValue, setExtraValue] = useState(0);
  // const [signFile, setSignFile] = useState(null);
  const [addQty, setAddQty] = useState(false);
  const [addHSN, setAddHSN] = useState(false);
  const [poNum, setPoNum] = useState("");
  const [poDate, setPoDate] = useState("");
  const [poEnabled, setPoEnabled] = useState(false);
  // Line items
  const initialItem = {
    description: "",
    hsn: "",
    quantity: 1,
    unitPrice: 0,
    unit: 0,
    unitType: "",
  };
  const [items, setItems] = useState([{ ...initialItem }]);
  const addItem = () => setItems((prev) => [...prev, { ...initialItem }]);
  const updateItem = (idx, field, value) => {
    const arr = [...items];
    arr[idx][field] = value;
    setItems(arr);
  };

  // Totals calculation
  const subtotal = items.reduce(
    (sum, i) =>
      sum + (addQty ? i.unitPrice * i.unit : i.quantity * i.unitPrice),

    0
  );
  const discountAmt = discountChecked ? (subtotal * discountRate) / 100 : 0;
  const taxableVal = subtotal - discountAmt;

  let cgstAmt = 0,
    sgstAmt = 0,
    igstAmt = 0,
    tax = 0;
  if (applyGST && gstRate) {
    if (gstType === "IGST") {
      igstAmt = (taxableVal * gstRate) / 100;
    } else if (gstType === "CGST_SGST") {
      cgstAmt = (taxableVal * gstRate) / 200;
      sgstAmt = cgstAmt;
    } else if (gstType === "TAX") {
      tax = (taxableVal * gstRate) / 100;
    }
  }
  const gstTotal = cgstAmt + sgstAmt + igstAmt + tax;
  const intermediateTotal = taxableVal + gstTotal;
  const extraAmt =
    extraType === "percent"
      ? (intermediateTotal * extraValue) / 100
      : extraValue;
  const totalBeforeRound = intermediateTotal + extraAmt;
  const finalTotal = roundOff ? Math.round(totalBeforeRound) : totalBeforeRound;
  const roundOffAmt = finalTotal - totalBeforeRound;
  const currencySymbol =
    CURRENCY_OPTIONS.find((c) => c.code === currency)?.symbol || "";
  const currencyLabel =
    CURRENCY_OPTIONS.find((c) => c.code === currency)?.name || "";
  const amountInWords = convertToWords(Math.round(finalTotal));

  // i need to change the background when i change the usestate background

  useEffect(() => {
    if (background === "Infratec") {
      setBackgroundImg(InfratecImg);
    } else if (background === "Infrastructure") {
      setBackgroundImg(InfrastructureImg);
    } else if (background === "M-Infratec LIC") {
      setBackgroundImg(M_InfratecImg);
    } else if (background === "M-Infratec") {
      setBackgroundImg(M_InfratecWOLic);
    } else {
      setBackgroundImg("None");
    }
  }, [background]);
  useEffect(() => {
    if (bank === "hdfc_infras") {
      setBankDetails(InfrastructureHDFCBank);
    } else if (bank === "bob_infras") {
      setBankDetails(InfrastructureBOBBank);
    } else if (bank === "hdfc_infratec") {
      setBankDetails(InfratecBank);
    } else if (bank === "minfratec") {
      setBankDetails(MInfratecBank);
    }
  }, [bank]);

  // PDF generation
  const printRef = useRef();
  const handleSubmit = async (e) => {
    e.preventDefault();
    const canvas = await html2canvas(printRef.current, {
      scale: window.devicePixelRatio * 2, // 192 dpi on 2× screens
      useCORS: true,
    });
    const img = canvas.toDataURL("image/jpeg", 0.92);
    const pdf = new jsPDF({
      orientation: "p",
      unit: "px",
      format: [canvas.width, canvas.height], // ← magic line
    });
    // const w = pdf.internal.pageSize.getWidth();
    // const h = (canvas.height * w) / canvas.width;
    pdf.addImage(img, "JPEG", 0, 0, canvas.width, canvas.height);
    pdf.save(`Invoice_${invoiceNumber || "DOC"}.pdf`);
  };
  const removeItem = (idx) =>
    setItems((prev) => prev.filter((_, i) => i !== idx));

  // Helper: number → words
  function convertToWords(num) {
    const single = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const teens = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    if (num === 0) return "Zero";
    if (num < 10) return single[num];
    if (num < 20) return teens[num - 10];
    if (num < 100)
      return (
        tens[Math.floor(num / 10)] + (num % 10 ? " " + single[num % 10] : "")
      );
    if (num < 1000)
      return (
        single[Math.floor(num / 100)] +
        " Hundred" +
        (num % 100 ? " and " + convertToWords(num % 100) : "")
      );
    if (num < 100000)
      return (
        convertToWords(Math.floor(num / 1000)) +
        " Thousand" +
        (num % 1000 ? " " + convertToWords(num % 1000) : "")
      );
    if (num < 10000000)
      return (
        convertToWords(Math.floor(num / 100000)) +
        " Lakh" +
        (num % 100000 ? " " + convertToWords(num % 100000) : "")
      );
    return (
      convertToWords(Math.floor(num / 10000000)) +
      " Crore" +
      (num % 10000000 ? " " + convertToWords(num % 10000000) : "")
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {/* Invoice Preview */}
      <Paper
        ref={printRef}
        elevation={0}
        sx={{
          width: "794px",
          minHeight: "1123px",
          padding: "32px 20px",
          // border: "2px solid #800001",
          m: "0 auto",
          // bgcolor: "#ffeaea",
          position: "relative",
          background: `url(${backgroundImg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 1,
            pb: 1,
            height: "140px",
          }}
        ></Box>

        <Typography
          variant="h4"
          align="center"
          sx={{ fontWeight: "bold", color: "#000", mb: 2 }}
        >
          {quotation}
        </Typography>

        {/* Title & Info */}
        {invoicedetails && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              py: 1,
            }}
          >
            {deliveryto && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-around",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    Invoice No:
                  </Typography>
                  <Typography variant="body2">{invoiceNumber}</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    Invoice Date:
                  </Typography>
                  <Typography variant="body2">{invoiceDate}</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    Place of Service:
                  </Typography>
                  <Typography variant="body2">{placeOfSupply}</Typography>
                </Box>
              </Box>
            )}
          </Box>
        )}
        {poEnabled && deliveryto && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                PO No:
              </Typography>
              <Typography variant="body2">{poNum}</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                PO Date:
              </Typography>
              <Typography variant="body2">{poDate}</Typography>
            </Box>
          </Box>
        )}
        {/* Bill To & Delivery To */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
          <Box sx={{ width: "48%" }}>
            <Paper
              elevation={0}
              sx={{
                px: 2,
                // bgcolor: "#f8f9fa",
                // border: "1px solid #e0e0e0",
                borderRadius: 1,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 1,
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: "400" }}>
                  Bill To:
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "400", whiteSpace: "nowrap" }}
                >
                  <strong>{recipientName}</strong>
                </Typography>
              </Box>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                {recipientAddress1}
                <br />
                {recipientAddress2}
                <br />
                {recipientAddress3}
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: "bolder" }}>
                {recipientGSTIN}
              </Typography>
            </Paper>
          </Box>
          {deliveryto && (
            <Box sx={{ width: "48%" }}>
              <Paper
                elevation={0}
                sx={{
                  px: 2,
                  // bgcolor: "#f8f9fa",
                  // border: "1px solid #e0e0e0",
                  borderRadius: 1,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: 1,
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: "400" }}>
                    Delivery To:
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "400", whiteSpace: "nowrap" }}
                  >
                    <strong>{deliveryAddName}</strong>
                  </Typography>
                </Box>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  {deliveryAddress1}
                  <br />
                  {deliveryAddress2}
                  <br />
                  {deliveryAddress3}
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: "bolder" }}>
                  {deliveryGSTIN}
                </Typography>
              </Paper>
            </Box>
          )}
          {invoicedetails && (
            <>
              {!deliveryto && (
                <Box
                  sx={{
                    width: "48%",
                  }}
                >
                  <Paper
                    elevation={0}
                    sx={{
                      p: 2,
                      // bgcolor: "#f8f9fa",
                      // border: "1px solid #e0e0e0",
                      borderRadius: 1,
                    }}
                  >
                    <Box>
                      {/* Invoice No */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          gap: 2,
                        }}
                      >
                        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                          Invoice No:
                        </Typography>
                        <Typography variant="body2">{invoiceNumber}</Typography>
                      </Box>
                      {/* Invoice Date */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          gap: 2,
                        }}
                      >
                        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                          Invoice Date:
                        </Typography>
                        <Typography variant="body2">{invoiceDate}</Typography>
                      </Box>
                      {/* Place of Service */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          gap: 2,
                        }}
                      >
                        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                          Place of Service:
                        </Typography>
                        <Typography variant="body2">{placeOfSupply}</Typography>
                      </Box>
                      {poEnabled && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexDirection: "column",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              gap: 2,
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "bold" }}
                            >
                              PO No:
                            </Typography>
                            <Typography variant="body2">{poNum}</Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              gap: 2,
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "bold" }}
                            >
                              PO Date:
                            </Typography>
                            <Typography variant="body2">{poDate}</Typography>
                          </Box>
                        </Box>
                      )}
                    </Box>
                  </Paper>
                </Box>
              )}
              {/* Delivery to and then the options displayed for Invoice Details */}
            </>
          )}

          {poEnabled && invoicedetails === false && deliveryto === false && (
            <Box
              sx={{
                width: "48%",
              }}
            >
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  // bgcolor: "#f8f9fa",
                  // border: "1px solid #e0e0e0",
                  borderRadius: 1,
                }}
              >
                {poEnabled && (
                  <Box
                    sx={{
                      display:
                        deliveryto === true || invoicedetails === true
                          ? "none"
                          : "flex",
                      // display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 2,
                      }}
                    >
                      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                        PO No:
                      </Typography>
                      <Typography variant="body2">{poNum}</Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 2,
                      }}
                    >
                      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                        PO Date:
                      </Typography>
                      <Typography variant="body2">{poDate}</Typography>
                    </Box>
                  </Box>
                )}
              </Paper>
            </Box>
          )}
          {/* Delivery to and then the options displayed for Invoice Details */}
        </Box>

        {/* Item Details */}
        <Box sx={{ mb: 1 }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: "bold",
              mb: 1,
              // color: "#800001",
            }}
          >
            ITEM DETAILS
          </Typography>
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 1,
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                // bgcolor: "#f0f2f5",
                borderBottom: "1px solid #e0e0e0",
                p: 1.5,
              }}
            >
              <Box
                sx={{
                  flex: addHSN && addQty ? 2 : 3,
                  fontWeight: "800",
                  fontSize: "0.875rem",
                }}
              >
                Description
              </Box>
              {addHSN && (
                <Box sx={{ flex: 1, fontWeight: "800", fontSize: "0.875rem" }}>
                  HSN/SAC
                </Box>
              )}
              {addQty && (
                <Box sx={{ flex: 1, fontWeight: "bold", fontSize: "0.875rem" }}>
                  Unit
                </Box>
              )}
              {addQty && (
                <Box sx={{ flex: 1, fontWeight: "bold", fontSize: "0.875rem" }}>
                  Unit Price
                </Box>
              )}

              {/* <Box
                sx={{
                  width: 100,
                  textAlign: "right",
                  fontWeight: "bold",
                  fontSize: "0.875rem",
                }}
              >
                Unit Price
              </Box> */}
              <Box
                sx={{
                  width: 120,
                  textAlign: "right",
                  fontWeight: "800",
                  fontSize: "0.875rem",
                }}
              >
                Amount
              </Box>
            </Box>

            {/* Regular Items */}
            {items.map((it, idx) => (
              <Box
                key={idx}
                sx={{
                  display: "flex",
                  p: 1.5,
                  borderBottom:
                    idx < items.length - 1 ? "1px solid #e0e0e0" : "none",
                  // bgcolor: idx % 2 === 0 ? "#fff" : "#fafafa",
                }}
              >
                {/* if the description is long, it should move to next line */}
                <Box
                  sx={{
                    flex: addHSN && addQty ? 2 : 3,
                    fontSize: "0.875rem",
                    fontWeight: "bold",
                    wordBreak: "break-all",
                    mr: 1,
                  }}
                >
                  {it.description}
                </Box>
                {addHSN && (
                  <Box sx={{ flex: 1, fontSize: "0.875rem", fontWeight: 600 }}>
                    {it.hsn}
                  </Box>
                )}
                {addQty && (
                  <>
                    <Box
                      sx={{ flex: 1, fontSize: "0.875rem", fontWeight: 600 }}
                    >
                      {it.unit} {it.unitType}
                    </Box>
                    <Box
                      sx={{ flex: 1, fontSize: "0.875rem", fontWeight: 600 }}
                    >
                      {it.unitPrice.toFixed(2)}
                    </Box>
                  </>
                )}

                {/* <Box
                  sx={{
                    width: 100,
                    textAlign: "right",
                    fontSize: "0.875rem",
                  }}
                >
                  {currencySymbol}
                  {it.unitPrice.toFixed(2)}
                </Box> */}
                <Box
                  sx={{
                    width: 120,
                    textAlign: "right",
                    fontSize: "0.875rem",
                    fontWeight: 600,
                  }}
                >
                  {currencySymbol}
                  {(addQty
                    ? it.unit * it.unitPrice
                    : it.quantity * it.unitPrice
                  ).toFixed(2)}
                </Box>
              </Box>
            ))}

            {/* Service/Extra Charge Row */}
            {extraValue > 0 && (
              <Box
                sx={{
                  display: "flex",
                  p: 1.5,
                  borderBottom: "1px solid #e0e0e0",
                  bgcolor: items.length % 2 === 0 ? "#fff" : "#fafafa",
                }}
              >
                <Box sx={{ flex: 3, fontSize: "0.875rem" }}>
                  Service Charge
                  {extraType === "percent" ? ` (${extraValue}%)` : ""}
                </Box>
                <Box sx={{ flex: 1 }} />
                <Box
                  sx={{
                    width: 100,
                    textAlign: "right",
                    fontSize: "0.875rem",
                  }}
                >
                  {currencySymbol}
                  {extraAmt.toFixed(2)}
                </Box>
                <Box
                  sx={{
                    width: 120,
                    textAlign: "right",
                    fontSize: "0.875rem",
                  }}
                >
                  {currencySymbol}
                  {extraAmt.toFixed(2)}
                </Box>
              </Box>
            )}
          </Box>
        </Box>

        {/* Summary Section */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
          <Box
            sx={{
              width: 350,
              border: "1px solid #e0e0e0",
              borderRadius: 1,
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                p: 1.5,
                borderBottom: "1px solid #e0e0e0",
                // bgcolor: "#f8f9fa",
              }}
            >
              <Typography variant="body2">Subtotal</Typography>
              <Typography variant="body2">
                {currencySymbol}
                {subtotal.toFixed(2)}
              </Typography>
            </Box>
            {discountChecked && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  p: 1.5,
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                <Typography variant="body2">
                  Discount ({discountRate}%)
                </Typography>
                <Typography variant="body2">
                  -{currencySymbol}
                  {discountAmt.toFixed(2)}
                </Typography>
              </Box>
            )}
            {applyGST && (
              <>
                {gstType === "IGST" && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      p: 1.5,
                      borderBottom: "1px solid #e0e0e0",
                    }}
                  >
                    <Typography variant="body2">IGST ({gstRate}%)</Typography>
                    <Typography variant="body2">
                      {currencySymbol}
                      {igstAmt.toFixed(2)}
                    </Typography>
                  </Box>
                )}

                {gstType === "TAX" && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      p: 1.5,
                      borderBottom: "1px solid #e0e0e0",
                    }}
                  >
                    <Typography variant="body2">Tax ({gstRate}%)</Typography>
                    <Typography variant="body2">
                      {currencySymbol}
                      {tax.toFixed(2)}
                    </Typography>
                  </Box>
                )}

                {gstType === "CGST_SGST" && (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        p: 1.5,
                        borderBottom: "1px solid #e0e0e0",
                      }}
                    >
                      <Typography variant="body2">
                        CGST ({gstRate / 2}%)
                      </Typography>
                      <Typography variant="body2">
                        {currencySymbol}
                        {cgstAmt.toFixed(2)}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        p: 1.5,
                        borderBottom: "1px solid #e0e0e0",
                      }}
                    >
                      <Typography variant="body2">
                        SGST ({gstRate / 2}%)
                      </Typography>
                      <Typography variant="body2">
                        {currencySymbol}
                        {sgstAmt.toFixed(2)}
                      </Typography>
                    </Box>
                  </>
                )}
              </>
            )}
            {roundOff && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  p: 1.5,
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                <Typography variant="body2">Round Off Adjustment</Typography>
                <Typography variant="body2">
                  {currencySymbol}
                  {roundOffAmt.toFixed(2)}
                </Typography>
              </Box>
            )}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                p: 1.5,
                // bgcolor: "#800001",
                color: "#000",
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                TOTAL
              </Typography>
              <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                {currencySymbol}
                {finalTotal.toFixed(2)}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Amount in Words */}
        <Box
          sx={{
            p: 2,
            // bgcolor: "#f8f9fa",
            border: "1px solid #e0e0e0",
            borderRadius: 1,
            mb: 0.5,
          }}
        >
          <Typography variant="body2">
            <strong>Amount in Words:</strong> {amountInWords} {currencyLabel}{" "}
            {currencyLabel === "Rupees" ? "Only" : ""}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: paymentDetails ? "space-between" : "flex-end",
            mb: 1,
          }}
        >
          {paymentDetails && (
            <Box sx={{ mb: 0.5 }}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  mb: 1,
                  // color: "#800001",
                }}
              >
                PAYMENT DETAILS
              </Typography>
              <Box
                sx={{
                  p: 1,
                  border: "1px solid #e0e0e0",
                  borderRadius: 1,
                }}
              >
                <Typography sx={{ mb: 0.5 }}>
                  <strong>Bank Acc Name: </strong>
                  {bankDetails.bankAccName}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    gap: 0.2,
                    justifyContent: "space-between",
                    flexDirection: "column",
                  }}
                >
                  <Typography>
                    <strong>Bank Name: </strong> {bankDetails.bankName}
                  </Typography>
                  <Typography>
                    <strong>Acc No: </strong> {bankDetails.bankAccNo}
                  </Typography>
                  <Typography>
                    <strong>
                      {bankDetails.bankIFSC ? "IFSC" : "IBAN No"}{" "}
                    </strong>
                    {bankDetails.bankIFSC
                      ? bankDetails.bankIFSC
                      : bankDetails.IBANNumber}
                  </Typography>
                  <Typography>
                    <strong>Branch: </strong>
                    {bankDetails.bankBranch}
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}
          {seal && (
            <>
              {background === "Infrastructure" && (
                <Box
                  component={"img"}
                  src={MInfraSeal}
                  alt=""
                  sx={{ width: 135, height: 135, my: "auto" }}
                />
              )}
              {background === "Infratec" && (
                <Box
                  component={"img"}
                  src={MInfratecSeal}
                  alt=""
                  sx={{ width: 135, height: 135, my: "auto" }}
                />
              )}
              {background === "M-Infratec" && (
                <Box
                  component={"img"}
                  src={MInfraSeal}
                  alt=""
                  sx={{ width: 135, height: 135, my: "auto" }}
                />
              )}
            </>
          )}

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
              mt: paymentDetails ? 2 : 2.5,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "flex-end",
                height: paymentDetails ? "80%" : "100%",
              }}
            >
              {/* Authorized Signatory */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 0.5,
                  alignItems: "flex-end",
                  color: "#370A85",
                }}
              >
                <Typography variant="body2" sx={{ color: "#000" }}>
                  Authorized Signatory
                </Typography>

                {background === "Infrastructure" && (
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    For Mathura Infrastructure
                  </Typography>
                )}
                {background === "Infratec" && (
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    For Mathura Infratec
                  </Typography>
                )}
                {background === "M-Infratec" && (
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    For M-Infratec L.L.C-FZ
                  </Typography>
                )}
                {background === "M-Infratec LIC" && (
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    For M-Infratec L.L.C-FZ
                  </Typography>
                )}
              </Box>
              {/* Name and Designation */}
              {quotation !== "Quotation" && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.5,
                    alignItems: "flex-end",
                    mt: paymentDetails ? 0 : 8,
                    color: "#370A85",
                  }}
                >
                  <Typography variant="body2" sx={{ fontWeight: "bolder" }}>
                    P.KrishnaKumar
                  </Typography>
                  <Typography variant="body2">(General Manager)</Typography>
                </Box>
              )}
            </Box>

            {/* {infratec==="Infrastructure" ? (
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                Mathura Infratec
              </Typography>
            ) : (
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                Mathura Infrastructure
              </Typography>
            )} */}
          </Box>
        </Box>

        {/* Footer */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            width: "100%",
            alignItems: "center",
          }}
        >
          <Typography color="text.secondary">
            Thank you for your business!
          </Typography>
        </Box>
      </Paper>

      {/* Form Inputs */}
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          mt: 4,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography variant="h6">Enter Details</Typography>
        {/* Invoice Info */}
        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField
            label="Invoice No"
            value={invoiceNumber}
            onChange={(e) => setInvoiceNumber(e.target.value)}
            fullWidth
          />
          <TextField
            label="Invoice Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={invoiceDate}
            onChange={(e) => setInvoiceDate(e.target.value)}
            fullWidth
          />
          <TextField
            label="Place of Service"
            value={placeOfSupply}
            onChange={(e) => setPlaceOfSupply(e.target.value)}
            fullWidth
          />
        </Box>

        {/* Addresses */}
        <Typography
          sx={{
            textAlign: "center",
            fontSize: 20,
            fontWeight: "bolder",
          }}
        >
          Address
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            mb: 2,
          }}
        >
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <TextField
              label="Recipient Name"
              value={recipientName}
              onChange={(e) => setRecipientName(e.target.value)}
              fullWidth
            />
            <TextField
              label="Recipient GSTIN"
              value={recipientGSTIN}
              onChange={(e) => setRecipientGSTIN(e.target.value)}
              fullWidth
            />
            {/* <TextField
              label="Recipient Contact"
              value={recipientContactDetails}
              onChange={(e) => setRecipientContactDetails(e.target.value)}
              
              fullWidth
            /> */}
            <TextField
              label="Recipient Address 1"
              value={recipientAddress1}
              onChange={(e) => setRecipientAddress1(e.target.value)}
              fullWidth
            />
            <TextField
              label="Recipient Address 2"
              value={recipientAddress2}
              onChange={(e) => setRecipientAddress2(e.target.value)}
              fullWidth
            />
            <TextField
              label="Recipient Address 3"
              value={recipientAddress3}
              onChange={(e) => setRecipientAddress3(e.target.value)}
              fullWidth
            />
          </Box>
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <TextField
              label="Delivery Name"
              value={deliveryAddName}
              onChange={(e) => setDeliveryAddName(e.target.value)}
              fullWidth
            />
            <TextField
              label="Delivery GSTIN"
              value={deliveryGSTIN}
              onChange={(e) => setDeliveryGSTIN(e.target.value)}
              fullWidth
            />
            {/* <TextField
              label="Delivery Contact"
              value={deliveryContactDetails}
              onChange={(e) => setDeliveryContactDetails(e.target.value)}
              
              fullWidth
            /> */}
            <TextField
              label="Delivery Address 1"
              value={deliveryAddress1}
              onChange={(e) => setDeliveryAddress1(e.target.value)}
              fullWidth
            />
            <TextField
              label="Delivery Address 2"
              value={deliveryAddress2}
              onChange={(e) => setDeliveryAddress2(e.target.value)}
              fullWidth
            />
            <TextField
              label="Delivery Address 3"
              value={deliveryAddress3}
              onChange={(e) => setDeliveryAddress3(e.target.value)}
              fullWidth
            />
          </Box>
        </Box>

        {/* PO Updates */}
        {poEnabled && (
          <>
            <Typography variant="subtitle1">PO Updates</Typography>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                label="PO Number"
                value={poNum}
                onChange={(e) => setPoNum(e.target.value)}
                fullWidth
              />
              <TextField
                label="PO Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={poDate}
                onChange={(e) => setPoDate(e.target.value)}
                fullWidth
              />
            </Box>
          </>
        )}

        {/* Items Input */}
        <Typography variant="subtitle1">Items</Typography>
        {items.map((item, idx) => (
          <Box
            key={idx}
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <TextField
              label="Description"
              value={item.description}
              onChange={(e) => updateItem(idx, "description", e.target.value)}
              sx={{ flex: 2 }}
            />
            {addHSN && (
              <TextField
                label="HSN/SAC"
                value={item.hsn}
                onChange={(e) => updateItem(idx, "hsn", e.target.value)}
                sx={{ flex: 1 }}
              />
            )}
            {addQty && (
              <>
                <TextField
                  label="unit"
                  type="number"
                  value={item.unit}
                  onChange={(e) => updateItem(idx, "unit", e.target.value)}
                  sx={{ flex: 1 }}
                />

                <TextField
                  label="Unit Price"
                  type="number"
                  value={item.unitPrice}
                  onChange={(e) =>
                    updateItem(idx, "unitPrice", Number(e.target.value))
                  }
                  sx={{ width: 120 }}
                />
              </>
            )}
            {addQty && (
              <FormControl sx={{ minWidth: 140 }}>
                <InputLabel>Unit Type</InputLabel>
                <Select
                  value={item.unitType}
                  onChange={(e) => updateItem(idx, "unitType", e.target.value)}
                  label="Unit Type"
                >
                  <MenuItem value="Nos">Numbers</MenuItem>
                  <MenuItem value="Sqft">Sqft</MenuItem>
                  <MenuItem value="Sqm">Sqm</MenuItem>
                  <MenuItem value="Rft">Rft</MenuItem>
                  <MenuItem value="Box">Box</MenuItem>
                </Select>
              </FormControl>
            )}

            {/* <TextField
              label="unit Price"
              value={item.quantity}
              onChange={(e) => updateItem(idx, "quantity", e.target.value)}
              sx={{ flex: 1 }}
            /> */}
            {!addQty && (
              <TextField
                label="Item Total"
                type="number"
                value={item.unitPrice}
                onChange={(e) =>
                  updateItem(idx, "unitPrice", Number(e.target.value))
                }
                sx={{ width: 120 }}
              />
            )}

            {/* Remove button */}
            <IconButton
              size="small"
              onClick={() => removeItem(idx)}
              sx={{ ml: 1 }}
            >
              <RemoveCircleOutlineIcon fontSize="small" />
            </IconButton>
          </Box>
        ))}
        <Button
          startIcon={<AddCircleOutlineIcon />}
          onClick={addItem}
          sx={{ alignSelf: "flex-start" }}
        >
          Add Item
        </Button>

        {/* Options */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            alignItems: "center",
          }}
        >
          {/* GST */}
          <FormControlLabel
            control={
              <Checkbox
                checked={applyGST}
                onChange={(e) => setApplyGST(e.target.checked)}
              />
            }
            label="Apply TAX"
          />
          {applyGST && (
            <>
              <FormControl sx={{ minWidth: 140 }}>
                <InputLabel>Tax Type</InputLabel>
                <Select
                  value={gstType}
                  onChange={(e) => setGstType(e.target.value)}
                  label="Tax Type"
                >
                  <MenuItem value="TAX">TAX</MenuItem>
                  <MenuItem value="IGST">IGST</MenuItem>
                  <MenuItem value="CGST_SGST">CGST + SGST</MenuItem>
                </Select>
              </FormControl>
              {gstType === "TAX" ? (
                <TextField
                  label="Tax %"
                  type="number"
                  value={gstRate}
                  onChange={(e) => setGstRate(Number(e.target.value))}
                  sx={{ width: 120 }}
                />
              ) : (
                <FormControl sx={{ minWidth: 100 }}>
                  <InputLabel>Rate (%)</InputLabel>
                  <Select
                    value={gstRate}
                    onChange={(e) => setGstRate(Number(e.target.value))}
                    label="Rate (%)"
                  >
                    {GST_RATES.map((r) => (
                      <MenuItem key={r} value={r}>
                        {r}%
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </>
          )}
          {/* Discount */}

          {discountChecked && (
            <TextField
              label="Discount %"
              type="number"
              value={discountRate}
              onChange={(e) => setDiscountRate(Number(e.target.value))}
              sx={{ width: 120 }}
            />
          )}

          {/* Round Off */}
          <FormControlLabel
            control={
              <Checkbox
                checked={roundOff}
                onChange={(e) => setRoundOff(e.target.checked)}
              />
            }
            label="Round Off Total"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={poEnabled}
                onChange={(e) => setPoEnabled(e.target.checked)}
              />
            }
            label="Enable PO"
          />
          <Box>
            {/* Round Off */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={paymentDetails}
                  onChange={(e) => setPaymentDetails(e.target.checked)}
                />
              }
              label="Payment Details"
            />
            {/* DOCUMENT Type */}

            {/* <FormControlLabel
              control={
                <Checkbox
                  checked={infratec}
                  onChange={(e) => setInfratec(e.target.checked)}
                />
              }
              label="Infratec"
            /> */}
            {/* Round Off */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={deliveryto}
                  onChange={(e) => setDeliveryto(e.target.checked)}
                />
              }
              label="Delivery to"
            />

            {/* <FormControlLabel
            control={
              <Checkbox
                checked={quotation}
                onChange={(e) => setQuotation(e.target.checked)}
              />
            }
            label="Quotation"
          /> */}

            <FormControlLabel
              control={
                <Checkbox
                  checked={invoicedetails}
                  onChange={(e) => setInvoicedetails(e.target.checked)}
                />
              }
              label="Invoice Details"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={addQty}
                  onChange={(e) => setAddQty(e.target.checked)}
                />
              }
              label="Qty"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={addHSN}
                  onChange={(e) => setAddHSN(e.target.checked)}
                />
              }
              label="HSN/SAC"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={seal}
                  onChange={(e) => setSeal(e.target.checked)}
                />
              }
              label="Seal"
            />
          </Box>
          {/* Currency Selector */}
          <FormControl sx={{ minWidth: 140 }}>
            <InputLabel>Currency</InputLabel>
            <Select
              value={currency}
              onChange={(e) => setCurrency(e.target.value)}
              label="Currency"
            >
              {CURRENCY_OPTIONS.map((c) => (
                <MenuItem key={c.code} value={c.code}>
                  {c.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: 140 }}>
            <InputLabel>Type</InputLabel>
            <Select
              value={quotation}
              onChange={(e) => setQuotation(e.target.value)}
              label="Type"
            >
              <MenuItem value="Quotation">Quotation</MenuItem>
              <MenuItem value="Invoice">Invoice</MenuItem>
              <MenuItem value="RA Bill">RA Bill</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: 140 }}>
            <InputLabel>Background</InputLabel>
            <Select
              value={background}
              onChange={(e) => setBackground(e.target.value)}
              label="Background"
            >
              <MenuItem value="None">None</MenuItem>
              <MenuItem value="Infrastructure">Infrastruture</MenuItem>
              <MenuItem value="Infratec">Infratec</MenuItem>
              <MenuItem value="M-Infratec LIC">M-Infratec LIC</MenuItem>
              <MenuItem value="M-Infratec">M-Infratec</MenuItem>
            </Select>
          </FormControl>

          <FormControl sx={{ minWidth: 140 }}>
            <InputLabel>Bank Details</InputLabel>
            <Select
              value={bank}
              onChange={(e) => setBank(e.target.value)}
              label="Bank Details"
            >
              <MenuItem value="hdfc_infras">HDFC - Infras</MenuItem>
              <MenuItem value="bob_infras">BOB - Infras</MenuItem>
              <MenuItem value="hdfc_infratec">HDFC - Infratec</MenuItem>
              <MenuItem value="minfratec">RAK - M-Infratec</MenuItem>
            </Select>
          </FormControl>
          {/* create a image upload button value to a state, with single file only and allow only jpeg, jpg and png */}
          {/* <Button variant="outlined" component="label">
            Upload Sign
            <input
              type="file"
              hidden
              accept=".jpeg,.jpg,.png"
              onChange={(e) => setSignFile(e.target.files[0])}
            />
          </Button> */}
        </Box>

        <Button variant="contained" type="submit" sx={{ mt: 2 }}>
          Download Invoice
        </Button>
      </Box>
    </Container>
  );
}
